import React from "react";
import Loader from "react-loader";
import loaderOptions from "./LoadingBar";
import { LoaderProps } from "./types";

/**
 * A wrapper component for those with delayed content. The loader's intended
 * parent should have the style `position: relative.`
 * @deprecated use Loader instead if this pattern has to be used but prefer to
 * use Skeleton overall
 */
const ReactLoader = ({
  position,
  loaded,
  children,
  className,
}: LoaderProps) => {
  if (position) {
    loaderOptions.top = `${position}%`;
  }

  return (
    <Loader
      loaded={loaded}
      options={loaderOptions}
      {...(className ? { loadedClassName: className } : {})}
    >
      {children}
    </Loader>
  );
};

export default ReactLoader;
